<template>
    <span class="material-icons" v-if="attribute === 'name'"> done </span>
    <span class="material-icons" v-else-if="attribute === 'message'"> send </span>
    <span class="material-icons" v-else-if="attribute === 'email'"> alternate_email </span>
    <span class="material-icons" v-else-if="attribute === 'phone'"> phone </span>
    <span class="material-icons" v-else-if="attribute === 'language'"> language </span>
    <span class="material-icons" v-else-if="attribute === 'timezone'"> schedule </span>
    <span class="material-icons" v-else-if="attribute === 'hour'"> timer </span>
    <span class="material-icons" v-else-if="attribute === 'weekday'"> calendar_month </span>
    <span class="material-icons" v-else-if="attribute === 'segments'"> pie_chart </span>
    <span class="material-icons" v-else-if="attribute === 'tags'">tag</span>
    <span class="material-icons" v-else-if="attribute === 'gender'"> male </span>
    <span class="material-icons" v-else-if="attribute === 'country'"> place </span>
    <span class="material-icons" v-else-if="attribute === 'referrer'"> language </span>
    <span class="material-icons" v-else-if="attribute === 'url'"> link </span>
    <span class="material-icons" v-else-if="attribute === 'ip'"> laptop </span>
    <span class="material-icons" v-else-if="attribute === 'last_seen'"> calendar_today </span>
    <span class="material-icons" v-else-if="attribute === 'user_id'"> fingerprint </span>
    <span class="material-icons" v-else-if="attribute === 'department'"> category </span>
    <span class="material-icons" v-else-if="attribute === 'available_agents'"> support_agent </span>
    <span class="material-icons text-primary" v-else-if="attribute === 'platform'"> hub </span>
    <span class="material-icons text-primary" v-else-if="attribute === 'channelId'"> mediation </span>
    <span class="material-icons text-primary" v-else-if="attribute === 'metaReferrals'"> bolt </span>
    <span class="material-icons text-danger" v-else-if="attribute === 'offline_mode'"> wifi_off </span>
    <img src="/static/img/akinon.png" v-else-if="attribute.startsWith('akinon_')" class="custom-attr-logo" />
    <img src="/static/img/ideasoft.webp" v-else-if="attribute.startsWith('ideasoft_')" class="custom-attr-logo" />
    <img src="/static/img/chatbot/probel.png" v-else-if="attribute.startsWith('probel_')" class="custom-attr-logo" />
    <span class="material-icons" v-else> data_object </span>
</template>

<script>
import BLOCK_TYPES from "../../../block.types";

export default {
    name: "AttributeIconPreview",
    props: {
        attribute: {
            type: String,
            required: false,
            default: "",
        },
    },
    data() {
        return {
            BLOCK_TYPES,
        };
    },
};
</script>

<style lang="scss">
.custom-attr-logo {
    background: none !important;
    border-radius: 50%;
    width: 20px !important;
    height: 20px !important;
}
</style>
